// extracted by mini-css-extract-plugin
export default {"root":"_3tvaN","static-add-widget":"_1BDNw","staticAddWidget":"_1BDNw"};